import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firebase-firestore';
import 'firebase/firebase-functions';
import 'firebase/storage';
import config from './config';

firebase.initializeApp(config);

export const authRef = firebase.auth();
export const authObj = firebase.auth;
export const firestoreRef = firebase.firestore();
export const databaseRef = firebase.database().ref();
export const storageRef = firebase.storage().ref();
export const functionsRef = firebase.functions();

export const getRoll = firebase.functions().httpsCallable('getRollNumber');
export const likePost = firebase.functions().httpsCallable('upVoteForumPost');
export const likePostComment = firebase
  .functions()
  .httpsCallable('upVoteForumComment');

export async function LinkToGoogle() {}

export const sendEmailAddressVerification = async () => {
  await authRef.currentUser
    .sendEmailVerification()
    .then(() => {
      return true;
    })
    .catch(error => {
      return error;
    });
};
